// Day and night from the world clock (which only runs while someone is online).

/** One full day, in world-clock seconds. */
export const DAY_LENGTH = 20 * 60;
/** The world's first second is mid-morning. */
const OFFSET = 0.08;
const DUSK = 0.62;
const NIGHT = 0.7;
const DAWN = 0.94;

/** 0..1 through the current day (0 = dawn's end). */
export const dayPhase = (time: number) => (time / DAY_LENGTH + OFFSET) % 1;
export const dayNumber = (time: number) => Math.floor(time / DAY_LENGTH + OFFSET) + 1;
export const isNight = (time: number) => {
  const p = dayPhase(time);
  return p >= NIGHT - 0.02 && p < DAWN + 0.02;
};

/** 1 = full daylight, ~0.12 = darkest night. Smooth through dusk and dawn. */
export function daylight(time: number): number {
  const p = dayPhase(time);
  const dark = 0.12;
  if (p < DUSK) return 1;
  if (p < NIGHT) return 1 - ((p - DUSK) / (NIGHT - DUSK)) * (1 - dark);
  if (p < DAWN) return dark;
  return dark + ((p - DAWN) / (1 - DAWN)) * (1 - dark);
}

export function timeOfDay(time: number): string {
  const p = dayPhase(time);
  if (p < 0.3) return 'morning';
  if (p < DUSK - 0.08) return 'afternoon';
  if (p < NIGHT) return 'dusk';
  if (p < DAWN) return 'night';
  return 'dawn';
}
